import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Table from '../../../components/table';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';
import { getBanks } from '../../../reducers/banking';
import { bankRoutingFieldLabel, checkingAccountFieldLabel } from '../../../utilities/regime';

class BankingTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            func: undefined,
            showValues: false
        };

        this.setVisible = this.setVisible.bind(this);
    }

    componentDidMount() {
        const { job, contractorId, getBanks } = this.props;
        if ((!job || !job.contractor) && !contractorId) return;
        getBanks({ type: 'contractor', id: (job && job.contractor && job.contractor.id) || contractorId });
    }

    setVisible(value) {
        const { func } = this.state;
        if (func) {
            clearTimeout(func);
        }
        const cb = value === true ? setTimeout(() => this.setVisible(false), 15000) : undefined;
        this.setState({ ...this.state, showValues: value, func: cb });
    }

    render() {
        const { showValues } = this.state;
        const { banks, job } = this.props;
        const bank = banks && banks.length > 0 ? banks[0] : undefined;
        const mask = <span dangerouslySetInnerHTML={{ __html: '&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;' }} />;

        let tableData = {
            columns: [
                { valueMap: d => <span className="row-label">{d.label}</span>, size: 'col-xs-12 col-md-3' },
                { valueMap: d => <span className="row-value">{d.value}</span>, size: 'col-xs-12 col-md-9' }
            ],
            data: [
                { label: <FormattedMessage {...messages.bankName} />, value: bank ? (showValues ? bank.name : mask) : '-' },
                { label: <FormattedMessage {...bankRoutingFieldLabel(job.regime)} />, value: bank ? (showValues ? bank.routing : mask) : '-' },
                { label: <FormattedMessage {...checkingAccountFieldLabel(job.regime)} />, value: bank ? (showValues ? bank.account : mask) : '-' }
            ]
        };

        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-xs-12 group">
                        <div className="section-title no-select" style={{ display: 'inline-block' }}>
                            <FormattedMessage {...messages.directDeposit} />
                        </div>
                        <i className="worker-banking-toggle material-icons" onClick={() => this.setVisible(!showValues)}>
                            {showValues ? 'visibility_off' : 'visibility'}
                        </i>
                    </div>
                </div>

                <Table {...tableData} rowStyle={'onboarding-table-row'} />
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    banks: state.banking.banks
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getBanks
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(BankingTab);



// WEBPACK FOOTER //
// ./src/pages/worker/tabs/banking.jsx